const aiChatActionTypes = {
  SET_AI_CHAT_STATE: 'SET_AI_CHAT_STATE',
  SET_AI_CHAT_CONTEXT_ID: 'SET_AI_CHAT_CONTEXT_ID',
  SET_AI_CHAT_HISTORY: 'SET_AI_CHAT_HISTORY',
  SET_AI_CHAT_LOADING: 'SET_AI_CHAT_LOADING',
  SET_AI_CHAT_ERROR: 'SET_AI_CHAT_ERROR',
};

export default aiChatActionTypes;
